<template>
  <div id="KftAnalog">
    <SovecoNavBar />
    <div class="tabs is-boxed is-marginless">
      <ul class="vehicles_top_tabs">
        <li :class="isTabActive(0)" @click="clickTab(0)">
          <a>Ultima Posizione</a>
        </li>
        <li :class="isTabActive(1)" @click="clickTab(1)">
          <a>Sommario</a>
        </li>
        <li :class="isTabActive(2)" @click="clickTab(2)">
          <a>Settimana Passata</a>
        </li>
      </ul>
    </div>
    <template v-if="tabNo === 0">
      <div class="columns">
        <div class="column is-narrow">
          <RangeDate
            :sData="startData"
            :eData="endData"
            :mode="'date'"
            :kftVehicles="kftVehicles"
            :isLoading="isLoading"
            :vehicleVis="true"
          />
        </div>

        <div class="column pr-5" v-if="singleDeviceData !== null">
          <div class="box pt-5">
            <div class="field">
              <div class="columns">
                <div class="column is-one-quarter">
                  <label class="label">Targa</label>
                </div>
                <div class="column">
                  <label class="label">{{
                    currentVehicle.RegistrationPlate
                  }}</label>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="columns">
                <div class="column is-one-quarter">
                  <label class="label">Marca e Modello</label>
                </div>
                <div class="column">
                  <label class="label">
                    {{ currentVehicle.Producer }} -
                    {{ currentVehicle.Model }}</label
                  >
                </div>
              </div>
            </div>

            <div class="field">
              <div class="columns">
                <div class="column is-one-quarter">
                  <label class="label">Data</label>
                </div>
                <div class="column">
                  <label class="label">{{ singleDeviceData.date_rec }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="box">
            <div class="field">
              <div class="columns">
                <div class="column is-one-quarter">
                  <label class="label">Veicolo</label>
                </div>
                <div class="column">
                  <label class="label">{{
                    status[singleDeviceData.analogs.status]
                  }}</label>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="columns">
                <div class="column is-one-quarter">
                  <label class="label">Eccesso velocità</label>
                </div>
                <div class="column">
                  <label class="label">{{
                    overspeed[singleDeviceData.analogs.overspeed]
                  }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="box">
            <div class="field">
              <label class="label">Driver 1</label>
              <div class="columns">
                <div class="column is-one-quarter">
                  <label class="label">Card</label>
                </div>
                <div class="column">
                  <label class="label">{{
                    card[singleDeviceData.analogs.d1_card]
                  }}</label>
                </div>
              </div>
            </div>

            <div class="field">
              <div class="columns">
                <div class="column is-one-quarter">
                  <label class="label">Attività</label>
                </div>
                <div class="column">
                  <label class="label">{{
                    driverState[singleDeviceData.analogs.d1_work]
                  }}</label>
                </div>
              </div>
            </div>

            <div class="field">
              <div class="columns">
                <div class="column is-one-quarter">
                  <label class="label">Tempi di guida</label>
                </div>
                <div class="column">
                  <label class="label">{{
                    driverTimes[singleDeviceData.analogs.d1_times]
                  }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="box">
            <div class="field">
              <label class="label">Driver 2</label>
              <div class="columns">
                <div class="column is-one-quarter">
                  <label class="label">Card</label>
                </div>
                <div class="column">
                  <label class="label">{{
                    card[singleDeviceData.analogs.d2_card]
                  }}</label>
                </div>
              </div>
            </div>

            <div class="field">
              <div class="columns">
                <div class="column is-one-quarter">
                  <label class="label">Attività</label>
                </div>
                <div class="column">
                  <label class="label">{{
                    driverState[singleDeviceData.analogs.d2_work]
                  }}</label>
                </div>
              </div>
            </div>

            <div class="field">
              <div class="columns">
                <div class="column is-one-quarter">
                  <label class="label">Tempi di guida</label>
                </div>
                <div class="column">
                  <label class="label">{{
                    driverTimes[singleDeviceData.analogs.d2_times]
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="tabNo === 1">
      <div>
        <div class="columns">
          <div class="column is-narrow">
            <RangeDate
              :sData="startData"
              :eData="endData"
              :mode="'date'"
              :kftVehicles="kftVehicles"
              :isLoading="isLoading"
              :vehicleVis="true"
            />
          </div>

          <div class="column pr-5" v-if="bigData !== null">
            <div class="box pt-5">
              <div class="field">
                <div class="columns">
                  <div class="column is-one-quarter">
                    <label class="label">Targa</label>
                  </div>
                  <div class="column">
                    <label class="label">{{
                      currentVehicle.RegistrationPlate
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="field">
                <div class="columns">
                  <div class="column is-one-quarter">
                    <label class="label">Marca e Modello</label>
                  </div>
                  <div class="column">
                    <label class="label">
                      {{ currentVehicle.Producer }} -
                      {{ currentVehicle.Model }}</label
                    >
                  </div>
                </div>
              </div>

              <div class="field">
                <div class="columns">
                  <div class="column is-one-quarter">
                    <label class="label">Dal</label>
                  </div>
                  <div class="column">
                    <label class="label">{{ startData }}</label>
                  </div>
                </div>
              </div>

              <div class="field">
                <div class="columns">
                  <div class="column is-one-quarter">
                    <label class="label">Al</label>
                  </div>
                  <div class="column">
                    <label class="label">{{ endData }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="box">
              <div class="field">
                <div class="columns">
                  <div class="column is-one-quarter">
                    <label class="label">Veicolo in movimento </label>
                  </div>
                  <div class="column">
                    <label class="label">{{
                      minToString(bigData.tot_status)
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="field">
                <div class="columns">
                  <div class="column is-one-quarter">
                    <label class="label">Eccesso velocità</label>
                  </div>
                  <div class="column">
                    <label class="label">{{
                      minToString(bigData.tot_overspeed)
                    }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <div class="box">
                  <div class="field">
                    <label class="label">Driver 1</label>
                  </div>
                  <table>
                    <tr>
                      <td>Card inserita</td>
                      <td>{{ minToString(bigData.tot_d1_card) }}</td>
                    </tr>
                    <tr>
                      <td>Riposo</td>
                      <td>{{ minToString(bigData.tot_d1_work[0]) }}</td>
                    </tr>
                    <tr>
                      <td>Disponibile</td>
                      <td>{{ minToString(bigData.tot_d1_work[1]) }}</td>
                    </tr>
                    <tr>
                      <td>Lavoro</td>
                      <td>{{ minToString(bigData.tot_d1_work[2]) }}</td>
                    </tr>
                    <tr>
                      <td>Guida</td>
                      <td>{{ minToString(bigData.tot_d1_work[3]) }}</td>
                    </tr>
                    <tr>
                      <td>Errore</td>
                      <td>{{ minToString(bigData.tot_d1_work[4]) }}</td>
                    </tr>
                    <tr>
                      <td>N.D.</td>
                      <td>{{ minToString(bigData.tot_d1_work[5]) }}</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="column">
                <div class="box">
                  <div class="field">
                    <label class="label">Driver 2</label>
                  </div>
                  <table>
                    <tr>
                      <td>Card inserita</td>
                      <td>{{ minToString(bigData.tot_d2_card) }}</td>
                    </tr>
                    <tr>
                      <td>Riposo</td>
                      <td>{{ minToString(bigData.tot_d2_work[0]) }}</td>
                    </tr>
                    <tr>
                      <td>Disponibile</td>
                      <td>{{ minToString(bigData.tot_d2_work[1]) }}</td>
                    </tr>
                    <tr>
                      <td>Lavoro</td>
                      <td>{{ minToString(bigData.tot_d2_work[2]) }}</td>
                    </tr>
                    <tr>
                      <td>Guida</td>
                      <td>{{ minToString(bigData.tot_d2_work[3]) }}</td>
                    </tr>
                    <tr>
                      <td>Errore</td>
                      <td>{{ minToString(bigData.tot_d2_work[4]) }}</td>
                    </tr>
                    <tr>
                      <td>N.D.</td>
                      <td>{{ minToString(bigData.tot_d2_work[5]) }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="tabNo === 2">
      <div>
        <div class="columns">
          <div class="column is-narrow">
            <RangeDate
              :sData="startData"
              :eData="endData"
              :mode="'date'"
              :kftVehicles="kftVehicles"
              :isLoading="isLoading"
              :vehicleVis="true"
            />
          </div>
          <div class="column">
            <div v-if="isLoadingStats" class="spinner">
              <VueElementLoading
                :active="isLoadingGraph"
                spinner="ring"
                color="#0000FF"
                background-color="white"
              />
            </div>
            <div v-if="isReadyStats">
              <div class="box">
                {{ currentVehicle.RegistrationPlate }}&nbsp;{{
                  currentVehicle.Producer
                }}&nbsp;{{ currentVehicle.Model }}
                <br />
                Periodo dal {{ startData | date_reversesolo_filter }} fino al
                {{ endData | date_reversesolo_filter }}
              </div>
              <div class="box">
                <li>
                  <div class="columns">
                    <div class="column is-one-fifth">Km percorsi</div>
                    <div class="column is-narrow">
                      {{ Distance.toFixed(2) }}&nbsp;Km
                    </div>
                  </div>
                </li>
                <li>
                  <div class="columns">
                    <div class="column is-one-fifth">Carburante</div>
                    <div class="column is-narrow">
                      {{ FinalTachoLiter.toFixed(2) }}&nbsp;L
                    </div>
                  </div>
                </li>
                <li>
                  <div class="columns">
                    <div class="column is-one-fifth">Consumo Km/L</div>
                    <div class="column is-narrow">
                      {{ consumoKML.toFixed(2) }}&nbsp;Km/L
                    </div>
                  </div>
                </li>
              </div>

              <div class="box">
                <li>
                  <div class="columns">
                    <div class="column is-one-fifth">Velocità Max</div>
                    <div class="column is-narrow">{{ MaxSpeed }}&nbsp;Km/h</div>
                  </div>
                </li>
                <li>
                  <div class="columns">
                    <div class="column is-one-fifth">Giri Motore Max</div>
                    <div class="column is-narrow">{{ MaxRpm }}&nbsp;RPM</div>
                  </div>
                </li>
                <li>
                  <div class="columns">
                    <div class="column is-one-fifth">
                      Temperatura Max Motore
                    </div>
                    <div class="column is-narrow">
                      {{ MaxEngineTemp }}&nbsp;C°
                    </div>
                  </div>
                </li>
              </div>

              <div class="box">
                <li>
                  <div class="columns">
                    <div class="column is-one-fifth">
                      Chiave inserita motore spento
                    </div>
                    <div class="column is-narrow">
                      {{ TimeInKeyOnEngOff | seconds_hhmmss }}&nbsp;HH:MM:SS
                    </div>
                  </div>
                </li>
                <li>
                  <div class="columns">
                    <div class="column is-one-fifth">
                      Motore Acceso in Sosta
                    </div>
                    <div class="column is-narrow">
                      {{
                        TimeInKeyOnEngOnNotMoving | seconds_hhmmss
                      }}&nbsp;HH:MM:SS
                    </div>
                  </div>
                </li>
                <li>
                  <div class="columns">
                    <div class="column is-one-fifth">
                      Motore Acceso in Marcia
                    </div>
                    <div class="column is-narrow">
                      {{
                        TimeInKeyOnEngOnAndMoving | seconds_hhmmss
                      }}&nbsp;HH:MM:SS
                    </div>
                  </div>
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { ServiceBus } from '../ServiceBus.js'
import axios from 'axios'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
//import VueScrollTable from "./reusable/VueScrollTable.vue";
import RangeDate from './reusable/RangeDate.vue'
import Cruscotto from './reusable/Cruscotto.vue'
import VueElementLoading from 'vue-element-loading'
//import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/it'

export default {
  name: 'FmsAnalog',
  components: {
    // VueScrollTable,
    VueElementLoading,
    RangeDate,
    // Cruscotto
    // DatePicker
  },
  mixins: [UtilityMixin],
  data() {
    return {
      singleDeviceData: null,
      bigData: null,
      isLoading: false,
      isLoadingGraph: false,
      isLoadingStats: false,
      tabNo: 0,
      apiServer: '',
      startData: '',
      endData: '',
      auth: null,
      prefs: null,
      storyDataArray: [],

      kftVehicles: [],
      deviceData: [],
      windowHeight: 0,
      isHovering: {},
      rowsGraph: [],
      optionsChart: {},
      chartDataCollection: [],
      currentVehicle: null,

      isReadyStats: false,
      MaxSpeed: 0,
      MaxRpm: 0,
      MaxEngineTemp: 0,
      Distance: 0,
      FinalTachoLiter: 0,
      PrevTachoLiter: 0,
      TimeInKeyOnEngOff: 0,
      TimeInKeyOnEngOnNotMoving: 0,
      TimeInKeyOnEngOnAndMoving: 0,
      consumoKML: 0,
      status: ['FERMO', 'IN MOVIMENTO'],
      card: ['NON PRESENTE', 'PRESENTE'],
      overspeed: ['NO VIOLAZIONE', "ECCESSO DI VELOCITA'"],
      driverState: ['RIPOSO', 'DISPONIBILE', 'LAVORO', 'GUIDA', 'ERRORE', '-'],
      driverTimes: [
        'NORMALE',
        '15 min PRIMA 4.5H',
        '>4.5H',
        '15 min PRIMA 9H',
        '>9H',
        '15 min PRIMA 16H',
        '>16H',
        'ERRORE',
        '-',
      ],
    }
  },
  created() {
    const vm = this
    let d = new Date()
    vm.endData = d.toLocaleMysqlString()
    d.setDate(d.getDate() - 1)
    d.setHours(0)
    d.setMinutes(0)
    d.setSeconds(0)
    vm.startData = d.toLocaleMysqlString()
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    vm.api_serverKft = vm.getKFTServer()
    if (vm.auth === null || vm.auth.tipo == 3) {
      this.$router.push({
        path: 'login',
      })
    }

    ServiceBus.$on('setRangeDate', (obj) => {
      vm.startData = obj.startData
      vm.endData = obj.endData
      vm.currentVehicle = obj.item
      vm.isReadyStats = false
      switch (vm.tabNo) {
        case 0:
          vm.doGetStoryDataLast(obj.item)
          break
        case 1:
          vm.doGetStoryData(obj.item)
          break
        case 2:
          vm.doGraphStats(obj.item)
          break
      }
    })

    vm.$nextTick(function () {
      window.removeEventListener('resize', null)
      window.addEventListener('resize', vm.getWindowHeight)

      if (!vm.auth.flag_kft) {
        let lg = vm.nullString(vm.auth.login_kft)
        let pw = vm.nullString(vm.auth.password_kft)
        if (lg.length > 0 && pw.length > 0) {
          vm.$dialog
            .alert('Riprova il collegamento con il server KFT')
            .then(function (dialog) {
              vm.checkKFTServer()
            })
        } else {
          this.$dialog
            .alert('Servizio cronotachigrafo non attivato per ' + vm.auth.nome)
            .then(function (dialog) {
              vm.$router.push({ name: 'Map', params: { pcod: '' } })
            })
        }
      }
      vm.fillDate()
      vm.clickTab(0)
      vm.getWindowHeight(null)
    })
  },
  methods: {
    fillDate() {
      const vm = this
      let d = new Date()
      vm.endData = d.toLocaleMysqlString().split(' ')[0]
      d.setDate(d.getDate() - 1)
      d.setHours(0)
      d.setMinutes(0)
      d.setSeconds(0)
      vm.startData = d.toLocaleMysqlString().split(' ')[0]
    },
    clickTab(t) {
      let d
      const vm = this
      switch (t) {
        case 0:
          vm.tabNo = t
          setTimeout(function () {
            vm.getWindowHeight(null)
          }, 500)
          vm.GetListKFTVehicles()
          break
        case 1:
          vm.tabNo = t
          setTimeout(function () {
            vm.getWindowHeight(null)
          }, 500)
          break
        case 2:
          vm.tabNo = t
          setTimeout(function () {
            vm.getWindowHeight(null)
          }, 500)
          break
      }
    },
    get_image(id, value) {
      let img_link
      if (id == 'DDDType') {
        switch (value) {
          case 'C':
            img_link = './images/delivery-man.png'
            break
          case 'M':
            img_link = './images/truck.png'
            break
        }
      }
      return img_link
    },
    isTabActive(t) {
      const vm = this
      if (vm.tabNo == t) {
        return 'is-active'
      } else {
        return ''
      }
    },

    bitExtracted(number, k, p) {
      return ((1 << k) - 1) & (number >> (p - 1))
    },

    decodeAnalogs(storyData) {
      let n1 = storyData.a1 / 16
      let n2 = storyData.a2 / 16
      let n3 = storyData.a3 / 16
      let analogs = {}

      analogs.date = storyData.date_rec
      analogs.status = this.bitExtracted(n1, 2, 7)
      analogs.overspeed = this.bitExtracted(n2, 2, 7)

      analogs.d1_card = this.bitExtracted(n2, 2, 5)
      analogs.d1_work = this.bitExtracted(n1, 3, 1)
      analogs.d1_times = this.bitExtracted(n2, 4, 1)

      analogs.d2_card = this.bitExtracted(n3, 2, 5)
      analogs.d2_work = this.bitExtracted(n1, 3, 4)
      analogs.d2_times = this.bitExtracted(n3, 4, 1)

      return analogs
    },

    createElement(date_from, date_to, value) {
      let element = {}
      element.v = value
      element.from = date_from
      element.to = date_to
      return element
    },

    summarizeAnalogs(data_to) {
      const vm = this
      let analogs = []
      vm.storyDataArray.forEach((element) => {
        const vm = this
        let item = vm.decodeAnalogs(element)
        analogs.push(item)
      })

      let status = []
      let overspeed = []
      let d1_card = []
      let d1_work = []
      let d1_times = []
      let d2_card = []
      let d2_work = []
      let d2_times = []

      let cur_status = vm.createElement(
        analogs[0].date,
        null,
        analogs[0].status
      )
      let cur_overspeed = vm.createElement(
        analogs[0].date,
        null,
        analogs[0].overspeed
      )
      let cur_d1_card = vm.createElement(
        analogs[0].date,
        null,
        analogs[0].d1_card
      )
      let cur_d1_work = vm.createElement(
        analogs[0].date,
        null,
        analogs[0].d1_work
      )
      let cur_d1_times = vm.createElement(
        analogs[0].date,
        null,
        analogs[0].d1_times
      )
      let cur_d2_card = vm.createElement(
        analogs[0].date,
        null,
        analogs[0].d2_card
      )
      let cur_d2_work = vm.createElement(
        analogs[0].date,
        null,
        analogs[0].d2_work
      )
      let cur_d2_times = vm.createElement(
        analogs[0].date,
        null,
        analogs[0].d2_times
      )

      analogs.forEach((element) => {
        if (cur_status.v !== element.status) {
          cur_status.to = element.date
          cur_status.min = vm.diffMin(cur_status.to, cur_status.from)
          status.push(cur_status)
          cur_status = vm.createElement(element.date, null, element.status)
        }
        if (cur_overspeed.v !== element.overspeed) {
          cur_overspeed.to = element.date
          cur_overspeed.min = vm.diffMin(cur_overspeed.to, cur_overspeed.from)
          overspeed.push(cur_overspeed)
          cur_overspeed = vm.createElement(
            element.date,
            null,
            element.overspeed
          )
        }
        if (cur_d1_card.v !== element.d1_card) {
          cur_d1_card.to = element.date
          cur_d1_card.min = vm.diffMin(cur_d1_card.to, cur_d1_card.from)
          d1_card.push(cur_d1_card)
          cur_d1_card = vm.createElement(element.date, null, element.d1_card)
        }
        if (cur_d1_work.v !== element.d1_work) {
          cur_d1_work.to = element.date
          cur_d1_work.min = vm.diffMin(cur_d1_work.to, cur_d1_work.from)
          d1_work.push(cur_d1_work)
          cur_d1_work = vm.createElement(element.date, null, element.d1_work)
        }
        if (cur_d1_times.v !== element.d1_times) {
          cur_d1_times.to = element.date
          cur_d1_times.min = vm.diffMin(cur_d1_times.to, cur_d1_times.from)
          d1_times.push(cur_d1_times)
          cur_d1_times = vm.createElement(element.date, null, element.d1_times)
        }
        if (cur_d2_card.v !== element.d2_card) {
          cur_d2_card.to = element.date
          cur_d2_card.min = vm.diffMin(cur_d2_card.to, cur_d2_card.from)
          d2_card.push(cur_d2_card)
          cur_d2_card = vm.createElement(element.date, null, element.d2_card)
        }
        if (cur_d2_work.v !== element.d2_work) {
          cur_d2_work.to = element.date
          cur_d2_work.min = vm.diffMin(cur_d2_work.to, cur_d2_work.from)

          d2_work.push(cur_d2_work)
          cur_d2_work = vm.createElement(element.date, null, element.d2_work)
        }
        if (cur_d2_times.v !== element.d2_times) {
          cur_d2_times.to = element.date
          cur_d2_times.min = vm.diffMin(cur_d2_times.to, cur_d2_times.from)
          d2_times.push(cur_d2_times)
          cur_d2_times = vm.createElement(element.date, null, element.d2_times)
        }
      })

      cur_status.to = data_to
      cur_status.min = vm.diffMin(cur_status.to, cur_status.from)
      status.push(cur_status)
      cur_overspeed.to = data_to
      cur_overspeed.min = vm.diffMin(cur_overspeed.to, cur_overspeed.from)
      overspeed.push(cur_overspeed)
      cur_d1_card.to = data_to
      cur_d1_card.min = vm.diffMin(cur_d1_card.to, cur_d1_card.from)
      d1_card.push(cur_d1_card)
      cur_d1_work.to = data_to
      cur_d1_work.min = vm.diffMin(cur_d1_work.to, cur_d1_work.from)
      d1_work.push(cur_d1_work)
      cur_d1_times.to = data_to
      cur_d1_times.min = vm.diffMin(cur_d1_times.to, cur_d1_times.from)
      d1_times.push(cur_d1_times)
      cur_d2_card.to = data_to
      cur_d2_card.min = vm.diffMin(cur_d2_card.to, cur_d2_card.from)
      d2_card.push(cur_d2_card)
      cur_d2_work.to = data_to
      cur_d2_work.min = vm.diffMin(cur_d2_work.to, cur_d2_work.from)
      d2_work.push(cur_d2_work)
      cur_d2_times.to = data_to
      cur_d2_times.min = vm.diffMin(cur_d2_times.to, cur_d2_times.from)
      d2_times.push(cur_d2_times)

      vm.bigData = {}
      /*
      vm.bigData.status = status;
      vm.bigData.overspeed = overspeed;
      vm.bigData.d1_card = d1_card;
      vm.bigData.d1_work = d1_work;
      vm.bigData.d1_times = d1_times;
      vm.bigData.d2_card = d1_card;
      vm.bigData.d2_work = d1_work;
      vm.bigData.d2_times = d1_times;
      */

      vm.bigData.tot_status = vm.calcTotalMinuteDualState(status)
      vm.bigData.tot_overspeed = vm.calcTotalMinuteDualState(overspeed)
      vm.bigData.tot_d1_card = vm.calcTotalMinuteDualState(d1_card)
      vm.bigData.tot_d1_work = vm.calcTotalMinuteMultState(d1_work)
      vm.bigData.tot_d2_card = vm.calcTotalMinuteDualState(d2_card)
      vm.bigData.tot_d2_work = vm.calcTotalMinuteMultState(d2_work)
    },

    calcTotalMinuteDualState(a) {
      let tot = 0
      a.forEach((element) => {
        if (element.v === 1) {
          tot += element.min
        }
      })
      return tot
    },

    // puo' essere sostituita con uno switch
    calcTotalMinuteMultState(a) {
      let tot = [0, 0, 0, 0, 0, 0]
      const getTotalMinutes = (index, min) => (tot[index] += min)
      const map_work = {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        6: 4,
        7: 5,
      }
      a.forEach((element) => getTotalMinutes(map_work[element.v], element.min))
      return tot
    },

    async doGraphStats(item) {
      const vm = this
      vm.isReadyStats = false
      vm.MaxSpeed = 0
      vm.MaxRpm = 0
      vm.MaxEngineTemp = 0
      vm.Distance = 0
      vm.FinalTachoLiter = 0
      vm.PrevTachoLiter = 0
      vm.TimeInKeyOnEngOff = 0
      vm.TimeInKeyOnEngOnNotMoving = 0
      vm.TimeInKeyOnEngOnAndMoving = 0
      vm.isLoadingStats = true
      vm.consumoKML = 0
      vm.chartDataCollection = []
      await vm.doGetListDeviceData(item.PerifId)
      if (vm.deviceData.length > 0) {
        vm.deviceData.forEach((element) => {
          if (element.MaxSpeed > vm.MaxSpeed) {
            vm.MaxSpeed = element.MaxSpeed
          }
          if (element.MaxRpm > vm.MaxRpm) {
            vm.MaxRpm = element.MaxRpm
          }
          if (element.MaxEngineTemp > vm.MaxEngineTemp) {
            vm.MaxEngineTemp = element.MaxEngineTemp
          }
          vm.Distance += element.Distance
          vm.TimeInKeyOnEngOff += element.TimeInKeyOnEngOff
          vm.TimeInKeyOnEngOnNotMoving += element.TimeInKeyOnEngOnNotMoving
          vm.TimeInKeyOnEngOnAndMoving += element.TimeInKeyOnEngOnAndMoving
          if (vm.PrevTachoLiter > 0) {
            vm.FinalTachoLiter += element.FinalTachoLiter - vm.PrevTachoLiter
          }
          vm.PrevTachoLiter = element.FinalTachoLiter
        })
        vm.consumoKML = vm.Distance / vm.FinalTachoLiter
      }
      vm.isLoadingStats = false
      vm.isReadyStats = true
    },

    async doGraphFlotta() {
      const vm = this
      vm.isLoadingGraph = true
      vm.chartDataCollection = []
      await vm.doGetListDeviceData(null)

      vm.optionsChart = {
        title:
          'FLOTTA KM PERCORSI E CONSUMO CARBURANTE : ' +
          vm.reverseDateSolo(vm.startData) +
          ' - ' +
          vm.reverseDateSolo(vm.endData),
        height: 700,
        vAxis: {
          title: 'Veicoli',
          titleTextStyle: { color: '#333' },
          textStyle: { fontSize: 11 },
        },

        hAxes: {
          0: {
            format: '# Km/L',
            gridlines: { color: 'transparent' },
            textStyle: {
              fontSize: 11, // or the number you want
            },
          },
          1: {
            format: '# ',
            gridlines: { color: 'lightgrey' },
            textStyle: {
              fontSize: 11, // or the number you want
            },
          },
        },
        series: {
          0: { targetAxisIndex: 1 },
          1: { targetAxisIndex: 1 },
          2: { targetAxisIndex: 0 },
        },
        colors: ['green', 'blue', 'red'],
      }

      if (vm.deviceData.length > 0) {
        let vehicle

        vm.kftVehicles.forEach((element) => {
          element.tot_distance = 0
          element.prev_liters = 0
          element.tot_liters = 0
          element.kml = 0
        })

        vm.deviceData.forEach((element) => {
          vehicle = vm.kftVehicles.find(
            (obj) => obj.PerifId === element.PerifId
          )

          if (vehicle !== null || vehicle !== undefined) {
            if (vehicle.prev_liters > 0) {
              vehicle.tot_liters +=
                element.FinalTachoLiter - vehicle.prev_liters
            }
            vehicle.prev_liters = element.FinalTachoLiter
            vehicle.tot_distance += element.Distance
          }
        })

        vm.deviceData = []
        let temp = []

        temp.push(['Targa', 'Km', 'Litri', 'Km/L'])
        vm.kftVehicles.forEach((element) => {
          element.kml = element.tot_distance / element.tot_liters
          temp.push([
            element.RegistrationPlate,
            element.tot_distance,
            element.tot_liters,
            element.kml,
          ])
        })

        vm.chartDataCollection.push(temp)
      }
      vm.isLoadingGraph = false
    },

    async doGraphCarburanteAlt(item) {
      const vm = this
      vm.currentVehicle = item
      vm.isLoadingGraph = true
      vm.chartDataCollection = []
      await vm.doGetListDeviceData(item.PerifId)
      if (vm.deviceData.length > 0) {
        let dates = [
          ...new Set(
            vm.deviceData.map(
              (item) => item.DateYYYY + '-' + item.DateMM + '-' + item.DateDD
            )
          ),
        ]
        let oneGraph = []
        vm.rowsGraph = []
        let temp
        let tempObj

        for (let i = 0; i < dates.length; i++) {
          temp = []
          temp = vm.deviceData.filter(function (item) {
            return (
              item.DateYYYY + '-' + item.DateMM + '-' + item.DateDD === dates[i]
            )
          })
          vm.rowsGraph.push(temp)
        }
        vm.deviceData = []
        vm.optionsChart = {
          title: '',
          height: 300,
          hAxis: {
            title: '',
            titleTextStyle: { color: '#333' },
            format: 'HH:mm',
            textStyle: { fontSize: 9 },
          },
          vAxes: {
            0: {
              viewWindowMode: 'explicit',
              viewWindow: {
                max: 100,
                min: 0,
              },
              format: '# Km/h',
              gridlines: { color: 'transparent' },
              textStyle: {
                fontSize: 10, // or the number you want
              },
            },
            1: {
              gridlines: { color: 'lightgrey' },
              textStyle: {
                fontSize: 10, // or the number you want
              },
            },
          },
          series: {
            0: { targetAxisIndex: 1 },
            1: { targetAxisIndex: 1 },
            2: { targetAxisIndex: 0 },
          },
          colors: ['green', 'blue', 'red'],
        }

        vm.optionsChart.width = vm.grapBoxWidth - 40

        let tot_distance = 0
        let tot_liters = 0
        let prev_liters = 0

        for (let i = 0; i < vm.rowsGraph.length; i++) {
          oneGraph = vm.rowsGraph[i]
          temp = []

          temp.push(['', 'Litri', 'Km', 'Km/h'])

          for (let x = 0; x < oneGraph.length; x++) {
            tot_distance += parseInt(oneGraph[x].Distance, 10)
            if (prev_liters == 0) {
              prev_liters = parseInt(oneGraph[x].FinalTachoLiter, 10)
            }
            tot_liters = parseInt(oneGraph[x].FinalTachoLiter, 10) - prev_liters

            temp.push([
              oneGraph[x].FinalDate.split('T')[1],
              tot_liters,
              tot_distance,
              oneGraph[x].MaxSpeed,
            ])
          }
          tempObj = {}
          tempObj.date = vm.reverseDateSolo(dates[i])
          tempObj.vehicle = item.RegistrationPlate + ' ' + item.Producer
          tempObj.id = i
          tempObj.data = temp
          vm.chartDataCollection.push(tempObj)
        }
      }
      vm.rowsGraph = []
      vm.isLoadingGraph = false
      if (vm.chartDataCollection.length < 1) {
        vm.$dialog
          .alert('Nessun dato presente per questo mezzo in questo periodo')
          .then(function (dialog) {})
      }
    },

    async doGraphCarburante(item) {
      const vm = this
      vm.currentVehicle = item
      vm.isLoadingGraph = true
      vm.chartDataCollection = []
      await vm.doGetListFuelSingleTank(item)
      if (vm.deviceData.length > 0) {
        let dates = [
          ...new Set(
            vm.deviceData.map(
              (item) => item.DateYYYY + '-' + item.DateMM + '-' + item.DateDD
            )
          ),
        ]
        let oneGraph = []
        vm.rowsGraph = []
        let temp
        let tempObj

        for (let i = 0; i < dates.length; i++) {
          temp = []
          temp = vm.deviceData.filter(function (item) {
            return (
              item.DateYYYY + '-' + item.DateMM + '-' + item.DateDD === dates[i]
            )
          })
          vm.rowsGraph.push(temp)
        }
        vm.deviceData = []
        vm.optionsChart = {
          title: '',
          height: 300,
          hAxis: {
            title: '',
            titleTextStyle: { color: '#333' },
            format: 'HH:mm',
            textStyle: { fontSize: 9 },
          },
          vAxes: {
            0: {
              viewWindowMode: 'explicit',
              viewWindow: {
                max: 100,
                min: 0,
              },
              format: '# Km/h',
              gridlines: { color: 'transparent' },
              textStyle: {
                fontSize: 10, // or the number you want
              },
            },
            1: {
              gridlines: { color: 'lightgrey' },
              textStyle: {
                fontSize: 10, // or the number you want
              },
            },
          },
          series: {
            0: { targetAxisIndex: 1 },
            1: { targetAxisIndex: 1 },
            2: { targetAxisIndex: 0 },
          },
          colors: ['green', 'blue', 'red'],
        }

        vm.optionsChart.width = vm.grapBoxWidth - 40

        for (let i = 0; i < vm.rowsGraph.length; i++) {
          oneGraph = vm.rowsGraph[i]
          temp = []

          temp.push(['', 'Litri', 'Km', 'Km/h'])

          for (let x = 0; x < oneGraph.length; x++) {
            temp.push([
              oneGraph[x].Date.split('T')[1],
              oneGraph[x].SensorFuelMainTank,
              oneGraph[x].StoryTotalDistance,
              oneGraph[x].Speed,
            ])
          }

          tempObj = {}
          tempObj.date = vm.reverseDateSolo(dates[i])
          tempObj.vehicle = item.RegistrationPlate + ' ' + item.Producer
          tempObj.id = i
          tempObj.data = temp
          vm.chartDataCollection.push(tempObj)
        }
      }
      vm.rowsGraph = []
      vm.isLoadingGraph = false
      if (vm.chartDataCollection.length < 1) {
        vm.$dialog
          .alert('Nessun dato presente per questo mezzo in questo periodo')
          .then(function (dialog) {})
      }
    },
    async checkKFTServer() {
      const vm = this
      await vm.doLoginKft()
    },
    async doLoginKft() {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'loginkft',
          {
            group: 'SV',
            password: vm.auth.password_kft,
            name: vm.auth.login_kft,
            token: '',
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (response.data.login === 'ok') {
          vm.auth.tkn_kft = response.data.token
          vm.auth.flag_kft = true
          this.$dialog
            .alert('Collegamento con il server KFT riattivato.')
            .then(function (dialog) {})
        } else {
          this.$dialog
            .alert(
              'Errore di connessione con il server KFT. Controllare login o password KFT'
            )
            .then(function (dialog) {})
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },

    async GetListKFTVehicles() {
      const vm = this

      vm.isLoading = true
      try {
        const response = await axios.post(
          vm.api_server + 'GetListKFTVehicles',
          {
            token: vm.auth.tkn_kft,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.kftVehicles = response.data.data
          vm.isLoading = false
        }
      } catch (e) {
        console.log('error ' + e)
        vm.isLoading = false
      }
    },

    async doGetListDeviceData(perifid) {
      const vm = this
      vm.deviceData = []
      vm.isLoading = true
      let start = vm.newDate(vm.startData).toLocaleMysqlSpecialString(false)
      let end = vm.newDate(vm.endData).toLocaleMysqlSpecialString(true)

      try {
        const response = await axios.post(
          vm.api_server + 'GetListDeviceData',
          {
            token: vm.auth.tkn_kft,
            PerifId: perifid,
            DateFrom: start,
            DateTo: end,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.deviceData = response.data.data
          vm.isLoading = false
        }
      } catch (e) {
        console.log('error ' + e)
        vm.isLoading = false
      }
    },

    async doGetListFuelSingleTank(vehicle) {
      const vm = this

      let start = vm.newDate(vm.startData).toLocaleMysqlSpecialString(false)
      let end = vm.newDate(vm.endData).toLocaleMysqlSpecialString(true)
      try {
        const response = await axios.post(
          vm.api_server + 'GetListFuelSingleTank',
          {
            token: vm.auth.tkn_kft,
            PerifId: vehicle.PerifId,
            DateFrom: start,
            DateTo: end,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.deviceData = response.data.data
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },

    async doGetStoryData(perifid) {
      const vm = this
      vm.isLoading = true
      let start = vm.newDate(vm.startData).toLocaleMysqlSpecialString(false)
      let end = vm.newDate(vm.endData).toLocaleMysqlSpecialString(true)

      try {
        const response = await axios.post(
          vm.api_server + 'get_tacho',
          {
            cod: perifid.Name,
            start: start,
            end: end,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.storyDataArray = response.data
          vm.summarizeAnalogs(end)
          vm.isLoading = false
        }
      } catch (e) {
        console.log('error ' + e)
        vm.isLoading = false
      }
    },

    async doGetStoryDataLast(perifid) {
      const vm = this
      vm.isLoading = true

      try {
        const response = await axios.post(
          vm.api_server + 'get_tacho_last',
          {
            cod: perifid.Name,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.singleDeviceData = response.data
          vm.singleDeviceData.perifid = perifid
          vm.singleDeviceData.analogs = vm.decodeAnalogs(vm.singleDeviceData)

          vm.isLoading = false
        }
      } catch (e) {
        console.log('error doGetStoryDataLast' + e)
        vm.isLoading = false
        vm.singleDeviceData = null
      }
    },

    getWindowHeight(event) {
      const vm = this
      vm.windowHeight = document.documentElement.clientHeight

      let ele1 = document.getElementById('rangedate')
      if (ele1) {
        ele1.setAttribute('style', 'height:' + (vm.windowHeight - 300) + 'px')
      }
      let ele2 = document.getElementById('graphBox')
      if (ele2) {
        ele2.setAttribute('style', 'height:' + (vm.windowHeight - 125) + 'px')
        vm.grapBoxWidth = ele2.offsetWidth
      }
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.getWindowHeight)
    },
  },
}
</script>
